import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const dpiPurchaseLocaleModule: LocaleModule = {
  name: "dpiPurchase",
  messages: { en: en, it: it },
};
